import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokBusinessAdAccounts.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useTiktokBusinessAdAccountsQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokBusinessAdAccountsLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getTiktokBusinessAdAccountsQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getTiktokBusinessAdAccounts
  const [getTiktokBusinessAdAccountsQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokBusinessAdAccountsQuery, ...result };
};

export const useTiktokBusinessAdAccountsPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokBusinessAdAccounts = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokBusinessAdAccounts };
};
